import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { t } from '../../i18n/i18n';
import StarComplete from '../../assets/tests/StarComplete';
import StarEmpty from '../../assets/tests/StarEmpty';
import FormInputSearch from '../FormInputSearch/FormInputSearch';
import { RoutesKeys, WORKSPACE } from '../../constants/routes';
import { determineIconType } from '../../utils/determineIconWorkspace/determineIconWorkspace';
import WorkspaceIcon from '../../assets/sidebar/icons/WorkspaceIcon';
import './WorkspaceDropdownContent.scss';

const WorkspaceDropdownContent = ({
  worskpacesListFilter,
  searchWorkspace,
  setSearchWorkspace,
  setWorkspace,
  addFavorite,
  removeFavorite,
  createWorkspace,
  redirectToConfig,
  dropdownClassName = '',
  onClose,
  variant = 'home',
  currentWorkspaceId,
}) => {
  const handleWorkspaceClick = (workspaceId) => {
    setWorkspace(workspaceId);
    if (onClose) onClose();
  };

  const handleCreateClick = () => {
    createWorkspace();
    if (onClose) onClose();
  };

  const handleConfigClick = () => {
    redirectToConfig();
    if (onClose) onClose();
  };

  const baseClassName = variant === 'sidebar'
    ? 'workspace-dropdown-content-sidebar'
    : 'workspace-dropdown-content';

  return (
    <div className={`${baseClassName} bg-white b-radius-8 pt-2 ${dropdownClassName}`}>
      <FormInputSearch
        searchText={searchWorkspace}
        setSearchText={setSearchWorkspace}
        placeholder={t('WORKSPACE_INPUT_SEARCH')}
        className="w-90 mx-auto"
      />
      {!worskpacesListFilter.length ? (
        <div className="text-center my-2 p-3">
          <p className=" m-0 font-weight-600 text-dark mb-2">
            {t('WORKSPACE_EMPTY_STATE_TITLE')}
          </p>
          <p className=" m-0 text-dark font-weight-400">{t('WORKSPACE_EMPTY_STATE_SUBTITLE')}</p>
        </div>
      ) : (
        <ul className="workspace-dropdown-list custom-scrollbar">
          {worskpacesListFilter
            .sort((a, b) => (a.favorite === b.favorite ? 0 : a.favorite ? -1 : 1))
            .map((option) => (
              <li
                className={`cursor-pointer workspace-dropdown-option ${
                  option.id === currentWorkspaceId ? 'workspace-dropdown-option-active' : ''
                }`}
                key={option.id}
                role="option"
                aria-selected
              >
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{`${option.companyName} - ${option.name}`}</Tooltip>}
                >
                  <button
                    className="workspace-option-button bg-transparent border-0 p-0"
                    type="button"
                    onClick={() => handleWorkspaceClick(option.id)}
                    onKeyPress={() => handleWorkspaceClick(option.id)}
                    data-testid={`button-option-${option.name}`}
                  >
                    {determineIconType(option)}
                    <span className="workspace-option-name text-dark font-weight-600 text-xxs">
                      {option.name}
                    </span>
                  </button>
                </OverlayTrigger>
                <button
                  data-testid={`button-star-${option.id}`}
                  type="button"
                  className="workspace-option-star bg-transparent border-0 p-0"
                  onClick={() =>
                    !option.favorite ? addFavorite(option?.id) : removeFavorite(option?.id)
                  }
                >
                  {option.favorite ? (
                    <StarComplete testid={`star-complete-${option.id}`} />
                  ) : (
                    <StarEmpty />
                  )}
                </button>
              </li>
            ))}
        </ul>
      )}
      <div
        className="workspace-dropdown-footer"
        aria-hidden="true"
        key={RoutesKeys.WORKSPACE}
        data-testid="li-sidebar-workspace"
      >
        <Link className="d-flex align-items-center border-0 text-decoration-none" to={WORKSPACE} onClick={onClose}>
          <div className="d-flex align-items-center w-100">
            <div className="mr-2">
              {WorkspaceIcon}
            </div>
            <div className="font-weight-600 text-xxs text-gray">
              {t('WORKSPACE_PAGE_BANNER')}
            </div>
          </div>
        </Link>
      </div>
      <div className="workspace-dropdown-actions d-flex justify-content-between">
        <button
          data-testid="create-workspace-button"
          type="button"
          onClick={handleCreateClick}
          className="workspace-dropdown-action-button border-0 bg-transparent font-weight-600 text-xxs text-gray"
        >
          <span>+</span>
          {t('CREATE_WORKSPACE')}
        </button>
        <button
          data-testid="config-workspace-button"
          type="button"
          className="workspace-dropdown-action-button border-0 bg-transparent font-weight-600 text-xxs text-gray"
          onClick={handleConfigClick}
        >
          <span>⚙</span>
          {t('CONFIG_WORKSPACE')}
        </button>
      </div>
    </div>
  );
};

export default WorkspaceDropdownContent;
